import { define } from 'wicked-elements'

define('.lazy-image', {
  init() {
    // this.element is the <img> element
    this.element.style.opacity = '0';
    this.element.style.transition = 'opacity 0.5s';

    this.loadHandler = () => {
      this.element.style.opacity = '1';
    };

    this.element.addEventListener('load', this.loadHandler);

    // Handle the edge case when the image is already cached
    if (this.element.complete) {
      this.loadHandler();
    }
  },
  connected() {

  },
  disconnected() {
    // remove the event listener
    this.element.removeEventListener('load', this.loadHandler);
  }
});